import "./prasora-form.scss";
import m from "mithril";
import pf from "../pf";
import dbstore from "../tools/dbstore";
import {ButtonGroup, Icons} from "../plugins/construct-ui/index";
import tools from "../tools/tools";

export default () => {
	let state = {};
	const db = dbstore(
		{
			structure: {
				node: undefined,
				rid: undefined,
				formid: undefined,
				prefields: undefined,
				preparents: undefined,
				isadmin: undefined,
			},
			editmode: false,
			formplan: {
				pages: [],
			},
			page: undefined,
			step: undefined,
			data: {},
		},
		() => {
			state = db.states();
			m.redraw();
		}
	);

	async function LoadForm() {
		await pf
			.APIAction("GetFormStructure", {
				...state.structure,
			})
			.then((r) => {
				db.update({...r});

				if (!state.hasplan) {
					db.update({
						formplan: {
							pages: [
								{
									steps: [
										{
											title: `Add New ${state.caption}`,
											fields: state.fields.map((a) => {
												return a.name;
											}),
										},
									],
								},
							],
						},
					});
				}

				console.log({state});
			});
	}

	return {
		oninit: ({attrs: {...d}}) => {
			db.update({structure: d});
			LoadForm();
		},
		view: () => {
			return state.editmode
				? m(".form-manager-wrapper", [
						m(".title", `Form Manager: ${state.caption} (${state.structure.node})`),
						m(".pages", [
							state.formplan.pages.map((p, pi) => {
								return m(".form-page", [
									m(
										".page-title",
										tools.Text(p.title, (w) => {
											db.update({
												formplan: {
													pages: {
														[pi]: {
															title: w,
														},
													},
												},
											});
										})
									),
									m(".steps", [
										p.steps.map((s, si) => {
											return m(".page-step", [
												tools.Text(s.title, (w) => {
													db.update({
														formplan: {
															pages: {
																[pi]: {
																	steps: {
																		[si]: {
																			title: w,
																		},
																	},
																},
															},
														},
													});
												}),
												s.fields.map((f, fi) => {
													return m(".step-field");
												}),
											]);
										}),
										m(
											".new-step-page",
											{
												onclick: () => {
													db.update({
														formplan: {
															pages: {
																[pi]: {
																	steps: (st) => st.concat({title: `step ${p.steps.length + 1}`, fields: []}),
																},
															},
														},
													});
												},
											},
											tools.Icon(Icons.PLUS_CIRCLE)
										),
									]),
								]);
							}),
							m(
								".new-form-page",
								{
									onclick: () => {
										db.update({
											formplan: {
												pages: (p) =>
													p.concat({
														title: "page",
														steps: [
															{
																title: "step 1",
																fields: [],
															},
														],
													}),
											},
										});
									},
								},
								tools.Icon(Icons.PLUS_CIRCLE)
							),
						]),
				  ])
				: m(".prasora-form", [state.formplan.pages.filter((p, i) => i == state.page).map((p) => {})]);
		},
	};
};
